(function () {
    'use strict';

    angular.module('swif.fluid')

    .config(
        function($routeProvider) {
            'ngInject';
            $routeProvider.when('/fluid/consumption/table_view', {
                templateUrl: 'partials/fluid/consumption_table_view.html',
                controller: 'FluidConsumptionsController',
                reloadOnSearch: false
            });
            $routeProvider.when('/fluid/consumption/explorer_view', {
                templateUrl: 'partials/fluid/consumption_explorer_view.html',
                controller: 'FluidConsumptionsController',
                reloadOnSearch: false
            });
    })

    .factory('fluidConsumptionService',
        function($q, $uibModal, swif) {
            'ngInject';
            var service = {
                cachedFiles: {},
                createdMeters: []
            };

            service.createCollection = function() {
                var filter = {};
                swif.data.sortOn(filter, 'id', 'ASC');
                return swif.collections.createOrUpdate('fluids_consumptions', 'fluids_consumption', filter);
            };

            service.cacheFile = function(key, file) {
                service.cachedFiles[key] = file;
            };

            service.getCachedFile = function(key) {
                if (service.cachedFiles[key] !== undefined) {
                    return service.cachedFiles[key];
                } else {
                    return undefined;
                }
            };

            /**
             * @name createNewMeters
             * @description Create meters.
             *
             * @param {Array} - Array of meters.
             * @returns {Promise}
             */
            service.createNewMeters = function(meters) {
                var deferred = $q.defer();
                var defers = [];
                if (meters.length > 0) {
                    swif.message.addInfo('Meters creation');
                    var modalInstance = $uibModal.open({
                        templateUrl: 'partials/fluid/meters_create_modal.html',
                        controller: 'FluidMetersCreateModalController',
                        backdrop: 'static',
                        resolve: {
                            meters: function () {
                                return meters;
                            }
                        }
                    });
                    modalInstance.result.then(function () {
                        swif.message.addInfo('Meters created. Consumptions import');
                        deferred.resolve();
                    });
                } else {
                    deferred.resolve();
                }
                return deferred.promise;
            };

            return service;
        }
    )

    .controller('FluidConsumptionsController',
        function ($scope, $uibModal, swif, fluidConsumptionService, msgService, gettextCatalog) {
            console.log('init FluidConsumptionsController');

            $scope.loading = { child_consumptions: {} };

            fluidConsumptionService.createCollection().then(function (collection) {
                $scope.fluids_consumptions = collection;
            });

            $scope.callback = function (error, data) {
                if (data.action.id === 'import') {
                    swif.message.addInfo('File uploaded. Processing validation...');
                } else if (data.action.id === 'validate') {
                    fluidConsumptionService.createCollection().then(function (collection) {
                        $scope.fluids_consumptions = collection;
                    });
                    swif.message.addInfo('data imported successfully')
                } else {
                    $scope.fluids_consumptions.fasterCallback(data);
                }
            };

            $scope.preValidate = function (data) {
                var ret;
                if (data.action.id === 'import') {
                    // Cache file to import
                    fluidConsumptionService.cacheFile('consumptionsFile', data.model.csvToImport.file_origin);

                    swif.data.callKw(
                        data.model.contentType,
                        'validate_csv',
                        [data.model.csvToImport.file_origin],
                        {context: swif.user.getAuthenticatedUser().context},
                        undefined,
                        false
                    ).then(function (validatedData) {
                        var action = swif.action.getActionById('fluids_consumption', 'misc', 'validate', [data.model.csvToImport.file_origin]);
                        if (action) {
                            var options = {
                                preValidate: $scope.preValidate,
                                callback: $scope.callback
                            };
                            swif.action.dispatch('fluids_consumption', action, validatedData, options);
                        }
                        return true;
                    }).catch(function() {
                        var message = gettextCatalog.getString("This file couldn't be recognized. Please provide one of the followings formats: OpenGST, EDF (élec), EDF (gaz), Engie, Total Direct Energie, PLUM, Suez")
                        msgService.addError({
                            code: 200,
                            type: 'danger',
                            data: {
                                fault_code: message
                            }
                        });
                    });
                } else if (data.action.id === 'validate') {
                    // Check if meters have to be created then import consumptions
                    var meters = data.model.missing;
                    return fluidConsumptionService.createNewMeters(meters).then(function() {
                        return swif.data.callKw(
                            'fluids_consumption',
                            'import_csv',
                            [fluidConsumptionService.getCachedFile('consumptionsFile')],
                            {context: swif.user.getAuthenticatedUser().context}
                        ).then(function (recap) {
                            var modalInstance = $uibModal.open({
                                templateUrl: 'partials/fluid/consumption_import_recap_modal.html',
                                controller: 'FluidConsumptionsImportRecapController',
                                resolve: {
                                    recap: function () {
                                        return recap;
                                    }
                                }
                            });
                            return true;
                        });
                    });
                } else {
                    ret = $scope.fluids_consumptions.preValidate(data);
                }
                return ret;
            };

            /**
             * Watch for current item changes and reload child consumptions
             */
            $scope.$watch('fluids_consumptions.currentItem', function (consumption) {
                $scope.child_consumptions = {};

                if (consumption && consumption.id) {
                    var filter = {};

                    swif.data.addFilter(filter, 'parent_id', '=', consumption.id);
                    swif.message.loading($scope.loading.child_consumptions);

                    swif.collections
                        .createOrUpdate('fluids_child_consumptions', 'fluids_child_consumption', filter)
                        .then(function (consumptions) {
                            $scope.child_consumptions = consumptions;
                            swif.message.loading($scope.loading.child_consumptions, 'ok');
                        }, function () {
                            swif.message.loading($scope.loading.child_consumptions, 'ko');
                        });
                }
            }, true);
        }
    )

    .controller('FluidConsumptionImportController',
        function ($scope) {
            'ngInject';
            console.log('init FluidConsumptionImportController');
            var $ctrl = this;
            $ctrl.model = {};

            $ctrl.onChangeFile = function (newV, filename) {
                if (!newV) {
                    return;
                }
                $scope.model.csvToImport = $ctrl.model;
            }
        }
    )

    .controller('FluidImportConsumptionValidationController', function($scope, swifFrameworkService) {
        'ngInject';
        console.log('init FluidImportConsumptionValidationController');
        var $ctrl = this;
        var swif = swifFrameworkService;
        $ctrl.model = $scope.model;

        // Count valid consumptions to import and duplicates count
        $ctrl.consoCount = _.sum($ctrl.model.valid, c => c.import ? c.import.count : 0);
        $ctrl.duplicateCount = _.sum($ctrl.model.valid, d => d.duplicates ? d.duplicates.count : 0);

        var fields = ["id", "name"];
        $ctrl.equipmentCategories = [];
        $ctrl.meterCategories = [];
        $ctrl.sites = [];

        // Pagination
        $ctrl.missingLimit = 5;
        $ctrl.missingOffset = 0;
        $ctrl.totalPages = Math.ceil($ctrl.model.missing.length / $ctrl.missingLimit);
        $ctrl.page = 1;

        $ctrl.prevPage = function() {
            if ($ctrl.page > 0) {
                $ctrl.missingOffset -= 5;
                $ctrl.page--;
            }
        }

        $ctrl.nextPage = function() {
            if ($ctrl.page <= $ctrl.totalPages) {
                $ctrl.missingOffset += 5;
                $ctrl.page++;
            }
        }

        // Call data for select-one widgets only once
        var eqfilter = {}
        swif.data.addFilter(eqfilter, 'is_fluid_meter', '=', true);
        eqfilter.fields = fields;

        // Get equipment categories
        swif.data.searchRead('equipment_category', eqfilter).then(eqCat => {
            $ctrl.equipmentCategories = eqCat.records;
        });

        // Get meters categories
        swif.data.searchRead('fluids_category', {fields: fields}).then(metCat => {
            $ctrl.meterCategories = metCat.records;
        });

        // Get sites
        swif.data.searchRead('site', {fields: fields}).then(sites => {
            $ctrl.sites = sites.records;
        });

        // Set the same value for all meters
        $ctrl.changeAll = function(e, field) {
            if (e.id && e.name) {
                $ctrl.model.missing.map(meter => {
                    meter[field] = [e.id, e.name];
                });
            } else {
                $ctrl.model.missing.map(meter => {
                    delete meter[field];
                });
            }
        }

        // Delete all meters to create
        $ctrl.deleteAll = function() {
            $ctrl.model.missing.splice(0, $ctrl.model.missing.length);

            // Reset pagination
            $ctrl.totalPages = 1;
            $ctrl.page = 1;
        }

        // Delete a meter we don't want to create
        $ctrl.deleteMeterLine = function(ref) {
            var index = $ctrl.model.missing.findIndex(missing => missing.ref == ref);
            $ctrl.model.missing.splice(index, 1);

            // Recalculate pagination
            $ctrl.totalPages = Math.ceil($ctrl.model.missing.length / $ctrl.missingLimit);
        }
    })

    .controller('FluidConsumptionController',
        function ($scope, swif) {
            'ngInject';
            console.log('init FluidConsumptionController');

            $scope.filters = {
                meter_id: {}
            };
            $scope.unit = '';

            // On site filter change
            $scope.onSiteChange = function (site) {
                // Reset meter filter
                $scope.filters.meter_id = {};

                // If a site is selected, filter meters by its id
                if (site.id) {
                    swif.data.addFilter($scope.filters.meter_id, 'site_id', 'child_of', site.id);
                }
            };

            /**
             * Watch for meter changes and query for related category unit
             * Use a watcher here to handle initial data (onChange is not fired
             * on initial load by swif-widget-select-one)
             */
            $scope.$watch('model.meter_id', function (newMeter) {
                var params = {
                    fields: ['unit']
                };

                if (newMeter) {
                    // Query for meter category unit
                    swif.data.get('fluids_meter', newMeter[0], params).then(function (data) {
                        $scope.unit = data.unit;
                    });
                } else {
                    $scope.unit = '';
                }
            });

        }
    )

    .controller('FluidMetersCreateModalController',
        function($scope, $uibModalInstance, swif, fluidConsumptionService, meters) {
            'ngInject';
            console.log('init FluidMetersCreateModalController');

            var service = fluidConsumptionService;
            var create = true;
            $scope.total = meters.length;
            $scope.count = 0;
            $scope.percent = 0;

            // Clean service createdMeters before launch creation
            service.createdMeters.splice(0, service.createdMeters.length);

            function loopOnMeters() {
                _createmeter(meters[$scope.count], function() {
                    $scope.count++;
                    $scope.percent = Math.ceil(($scope.count / $scope.total) * 100);

                    if (create === true && $scope.count < $scope.total) {
                        loopOnMeters();
                    } else {
                        if ($uibModalInstance.opened.$$state.value) {
                            $uibModalInstance.close();
                        }
                    }
                });
            }
            loopOnMeters();

            function _createmeter(meter, success) {
                swif.data.create('fluids_meter', meter).then(function(res) {
                    // Added created meter to service's createdMeters list
                    var createdMeter = {
                        id: res,
                        ref: meter.ref,
                        name: meter.name
                    };
                    service.createdMeters.push(createdMeter);
                    success();
                });
            }

            $scope.close = function() {
                create = false;
                $uibModalInstance.close();
            }
        }
    )

    .controller('FluidConsumptionsImportRecapController',
        function($scope, $uibModalInstance, fluidConsumptionService, recap) {
            'ngInject';
            console.log('init FluidConsumptionsImportRecapController');
            var service = fluidConsumptionService;
            $scope.createdMeters = service.createdMeters;
            $scope.consumptions = recap.details;
            $scope.consoCount = _.sum(recap.details, meter => meter.import.count);

            $scope.close = function() {
                $uibModalInstance.close();
            }
        }
    )

    .component('consumptionTable', {
        templateUrl: 'partials/fluid/consumption_table_component.html',
        bindings: {
            consumption: '<',
            unit: '<?'
        },
        controller: function() {
            var ctrl = this;
        }
    })

    .component('panelConsumption', {
        templateUrl: 'partials/fluid/panel-consumption.html',
        bindings: {
            consumption: '<'
        },
        controller: function() {
            var ctrl = this;
        }
    });

})();
